import React, { Component } from 'react';
import './Menu.css';
import './IconButton.css';
import './SitePicker.css';
import Select from 'react-select';
import MenuType from '../enums/MenuType';
import IconButton from './IconButton';
import SubMenuHeader from './SubMenuHeader';
import ClickedOffManager from '../ui_core/ClickedOffManager';
export default class SitePicker extends Component {
	constructor(props){
		super(props)
		const {
			setSite
		} = props;
		this._setSite = setSite;
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._iMenuManager  = null;
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._handleChange = this._handleChange.bind(this);
		this.setSelectedSiteName = this.setSelectedSiteName.bind(this);
		this._options = null;
		this.state = {selectedOption:null, visible:false, options:[]};
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
	}
	setSelectedSiteName(value){
		this.setState({selectedOption:this._options.filter(option=>option.value===value)[0]});
	}
	load(sites){
		this._options = sites.getArray().map((site)=>{return {value:site.name, label:site.name};});
		this.setState({options:this._options});
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.SITE_PICKER;
	}
	_handleChange(e){
		const {value }= e;
		this._setSite(value);
	}
	render() {
		let className = "site-picker menu";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader}></SubMenuHeader>
			  <div className="select-wrapper"><Select
				value={this.state.selectedOption}
				onChange={this._handleChange}
				options={this.state.options}
			  />
			</div></div>)
	}
}